import React, { SFC } from 'react';
import RadioButton from '../../Generic/Input/RadioButton';
import { NewProductFilterValues } from '../../../redux/products/types';
import { FilterValue } from './filterValueService';

interface Props {
    name: string;
    radio: string;
    value: FilterValue;
    handleValueChange: (value: NewProductFilterValues) => void;
}

export const MultiRangeFilters: SFC<Props> = ({ radio, name, handleValueChange, value }): React.ReactElement => {
    let activeValue = '';
    if (value !== undefined && Array.isArray(value)) {
        activeValue = value[0] || '';
    }

    const isChecked = activeValue.toLocaleLowerCase() === radio.toLocaleLowerCase();

    return (
        <RadioButton
            isChecked={isChecked}
            text={radio}
            value={radio}
            onChange={() => handleValueChange({ name, value: radio })}
        />
    );
};

export default MultiRangeFilters;
